import axios from 'axios';
import { CONFIGS_URL } from '../constants/api.constants';

const axiosInstance = axios.create({});

export interface MsalConfig {
	msal: {
		auth: {
			clientId: string;
			authority: string;
			knownAuthorities: string[];
			redirectUri: string;
			postLogoutRedirectUri: string;
		};
	};
	cache: {
		cacheLocation: 'localStorage' | 'sessionStorage';
		storeAuthStateInCookie: boolean;
	};
	system: {
		allowRedirectInIframe: boolean;
		iframeHashTimeout: number;
	};
	interceptor: {
		protectedResourceMap: [string, string[]][];
	};
	apiConfig: {
		scopes: string[];
		uri: string;
	};
	b2cPolicies: {
		names: {
			kmsi: string;
			password_reset: string;
		};
		authorities: {
			[key: string]: {
				authority: string;
			};
		};
		authorityDomain: string;
	};
}

export interface IConfig {
	MSAL_CONFIG: MsalConfig;
	APP_DATA: {
		app_version: string;
		app_build: string;
	};
	MP_URL: string;
	SHOW_ERUDA: string;
}

export interface ApiResponse {
	[key: string]: unknown;
	data: IConfig;
}

export const fetchConfigs = (): Promise<ApiResponse> => {
	return axiosInstance.get(CONFIGS_URL);
};
